import { PermissionService } from './../../../../services/permissions/permission.service';
import { FuseRolesAndPermissionsComponent } from './roles-and-permissions.component';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../../../../core/modules/shared.module';

import { NgxPermissionsGuard } from 'ngx-permissions';
import { FuseWidgetModule } from 'app/core/components/widget/widget.module';
import { RoleService } from 'app/main/services/roles/role.service';
import { FuseAddRoleComponent } from 'app/main/content/pages/security/roles-and-permissions/components/add-role/add-role.component';

const routes = [
    {
        path: 'pages/security/roles-and-permissions',
        component: FuseRolesAndPermissionsComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
            permissions: {
                only: 'PAGES_SECURITY_ROLES_AND_PERMISSIONS',
                redirectTo: '/pages/errors/error-403'
            }
        }
    }
];

@NgModule({
    declarations: [
        FuseRolesAndPermissionsComponent,
        FuseAddRoleComponent
    ],
    imports: [
        SharedModule,
        RouterModule.forChild(routes),
        FuseWidgetModule
    ],
    exports: [
        FuseRolesAndPermissionsComponent
    ],
    providers: [
        RoleService,
        PermissionService
    ],
    entryComponents: [
        FuseAddRoleComponent
    ]
})

export class FuseRolesAndPermissionsModule {
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/security/roles-and-permissions/roles-and-permissions.module.ts